
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';
import './table.scss';

interface TableProps {
  tableData?: any;
}

const tableHead = [
  {
    name: "MOG Name",
  },
  {
    name: "Article Number",
  },
  {
    name: "Article Description (Standard Cost per Kg)",
  },
  {
    name: "Requested Theo Qty",
  },
  {
    name: "Requested Revised Qty",
  },
  {
    name: "Requested GI Qty",
  },
  {
    name: "Variance % on Revised vs GI",
  },
];
const FinalKitchenGIVarianceReportTable: React.FC<TableProps> = ({ tableData }) => {
  return (
    <div className="table-wrapper GIVarianceReportTable">
      <TableContainer component={Paper} className="table-inner" sx={{ maxHeight: 440 }}>
        <MuiTable stickyHeader>
          <TableHead>
            <TableRow>
              {tableHead.map((col: any, index: number) => (
                <TableCell key={index}>
                  <Typography variant="h6" className="table-title">{col?.name}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData?.length > 0 ? (
              tableData.map((row: any, index: number) => (
                <TableRow key={index}>
                  <TableCell>{row?.mogname}</TableCell>
                  <TableCell>{row?.articlenumber}</TableCell>
                  <TableCell>{row?.articledescription}</TableCell>
                  <TableCell>{row?.requestedtheoqty} Kg</TableCell>
                  <TableCell>{row?.requestedrevisedtheoqty} Kg</TableCell>
                  <TableCell>{row?.requestedgiqty} Kg</TableCell>
                  <TableCell>{row?.variance}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={tableHead.length} className="grey-bg center">
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </div>
  );
};

export default FinalKitchenGIVarianceReportTable;
